import React from 'react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import styles from './empty-message.module.scss';
interface EmptyMessageProps {
	description: string | JSX.Element;
	icon?: BringgFontIcons;
	'data-test-id'?: string;
	className?: string;
}

const EmptyMessage = ({ description, icon, className, 'data-test-id': dataTestId }: EmptyMessageProps) => {
	return (
		<div data-test-id={`empty-message ${dataTestId || ''}`} className={`${styles.emptyMessage} ${className || ''}`}>
			<BringgIcon iconName={icon || BringgFontIcons.MessageMail} className={styles.messageIcon} />
			<div>{description}</div>
		</div>
	);
};

export default EmptyMessage;
